import { useMemo } from "react";
import { useFamilyUsers } from "../../_common/queries";
import type { Profile } from "../../_common/services/kindlyApi";
import { ChipPicker, Spinner } from "@jkast90/kast-common/ui";

interface UserSelectorProps {
  selectedUserIds: number[];
  onChange: (selectedIds: number[]) => void;
  label?: string;
  className?: string;
  excludeUserIds?: number[];
}

const NO_USERS: Profile[] = [];

/** The family's people as the shared ChipPicker: ids in, ids out. */
export default function UserSelector({
  selectedUserIds,
  onChange,
  label = "Select Users",
  className = "",
  excludeUserIds = [],
}: UserSelectorProps) {
  const { data: users = NO_USERS, isPending: loading } = useFamilyUsers();

  const options = useMemo(
    () =>
      users
        .filter((user) => !excludeUserIds.includes(user.id))
        .map((user) => ({
          value: String(user.id),
          label: `${user.first_name} ${user.last_name}`,
          subtitle: user.email || undefined,
        })),
    [users, excludeUserIds],
  );

  if (loading) {
    return <Spinner showLabel label="Loading users..." />;
  }

  return (
    <ChipPicker
      className={className || undefined}
      label={label}
      options={options}
      value={selectedUserIds.map(String)}
      onChange={(values) => onChange(values.map(Number))}
      placeholder="Choose a person to add..."
    />
  );
}
